
import Swal from "sweetalert2";
import { useEffect, useRef, useState } from 'react';
import * as commonFunc from 'scripts/common';

// ajouter props, json, etc crypto ajouter params TypeRSA, ModulusLength
export default function AKeyHelperFrag(props) {
    // Hooks React : 
    const keyRef = useRef(null);//Moteur clé public
    const aesKeyRef = useRef(null);//CryptoKey content
    const IVRef = useRef(null);//ArrayBuffer content

    // Constantes Internes :
    const modulusLength = (props.modulusLength) ? props.modulusLength : 2048;
    const typeRSA = (props.typeRSA) ? props.typeRSA : 'RSA-OAEP';
    const padding = (props.padding) ? props.padding : 'SHA-1';
    const actionsOfKey = (props.actionsOfKey) ? props.actionsOfKey : ['encrypt', 'decrypt'];

    // Effects : 
    useEffect(() => {
        props.data.functionManager.launchKeyHelper();
        return () => {
            console.debug("Destroy KeyHelper");

            //CLEANING
            keyRef.current = null;
            aesKeyRef.current = null;
            IVRef.current = null;
        }
    }, []);


    function sendPublicKey(publicKey, item) {
        getRSAPublicKeytoPEMasync(publicKey).then((value) => {
            const args = {
                publicKeyPEM: value,
                algo: publicKey.algorithm.hash.name
            }
            if (item) args.item = item;
            commonFunc.postMethod((item ? "../api/data/RefactorAesKeyWithRSA" : "../api/data/PreparePublicRSAKey"), args).then((response) => {
                if (response.data) {
                    if (response.data.isSuccess) {
                        decrypt(keyRef.current.privateKey, response.data.result).then((aesObject) => {
                            const result = JSON.parse(aesObject);
                            const aesKeyArrayBuffer = base64ToArrayBuffer(result.K);
                            IVRef.current = base64ToArrayBuffer(result.V);

                            window.crypto.subtle.importKey("raw", aesKeyArrayBuffer, { name: "AES-CBC" }, false, ['encrypt', 'decrypt']).then((aesKey) => {//AES-GCM
                                console.debug("AES Key ready to work !!!");
                                aesKeyArrayBuffer.fill(0);//CLEANING

                                aesKeyRef.current = aesKey;

                                if (props.endCb) {
                                    //props.endCb("aes", response.data.extraInfo);
                                    if (response.data.extraInfo) {
                                        decrypt(aesKeyRef.current, response.data.extraInfo, IVRef.current).then((messageDecoded) => {
                                            //console.debug(messageDecoded);
                                            //setEx(messageDecoded);
                                            props.endCb("aes", messageDecoded);
                                        });
                                    }
                                    else props.endCb("aes");
                                }
                                else {
                                    //TEST
                                    encrypt(aesKeyRef.current, "Salut les copains", IVRef.current).then((messageEncoded) => {
                                        console.debug(messageEncoded);
                                        decrypt(aesKeyRef.current, messageEncoded, IVRef.current).then((messageDecoded) => {
                                            console.debug(messageDecoded);
                                            //setEx(messageDecoded);
                                        });
                                    });
                                }
                                aesKey = null;//CLEANING
                            });
                        });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Traitement d'authentification échoué",
                            html: response.data.errorMessage
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Erreur, aucune réponse",
                    });
                }
            });
        })
    }


    props.data.functionManager = {}
    props.data.functionManager.getPEM = function (messageNotEncoded) {
        if (keyRef.current?.publicKey) {
            return getRSAPublicKeytoPEMasync(keyRef.current.publicKey).then((value) => {
                const args = {
                    publicKeyPEM: value,
                    algo: keyRef.current.publicKey.algorithm.hash.name
                }
                return new Promise(resolve => {
                    resolve(args);
                });
            });
        }
        return new Promise(resolve => {
            resolve(null);
        });
    }
    props.data.functionManager.prepareAES = function () {
        sendPublicKey(keyRef.current.publicKey);
    }
    props.data.functionManager.managerSingleField = function (encodedItem) {
        return new Promise(resolve => {
            if (aesKeyRef.current) {
                props.data.functionManager.decryptAES(encodedItem.value).then(value => {
                    resolve(value);
                });
            }
            else {
                sendPublicKey(keyRef.current.publicKey, encodedItem);
                resolve(null);
            }
        });
    }
    props.data.functionManager.encryptAES = async function (messageNotEncoded) {
        if (!aesKeyRef || !aesKeyRef.current || !IVRef || !IVRef.current) return;
        return await encrypt(aesKeyRef.current, messageNotEncoded, IVRef.current);
    }
    props.data.functionManager.decryptAES = async function (messageEncoded) {
        if (!aesKeyRef || !aesKeyRef.current || !IVRef || !IVRef.current) return;
        return await decrypt(aesKeyRef.current, messageEncoded, IVRef.current);
    }
    props.data.functionManager.launchKeyHelper = async function () {
        const subtleCrypto = window.crypto.subtle;
        keyRef.current = await subtleCrypto.generateKey({
            name: typeRSA,
            modulusLength: modulusLength,
            publicExponent: new Uint8Array([1, 0, 1]),
            hash: padding
        }, true, actionsOfKey)
        //console.log(keyRef.current);
        //sendPublicKey(keyRef.current.publicKey);
        if (props.endCb) props.endCb("rsa");
        else sendPublicKey(keyRef.current.publicKey);
    }

    return (<div>
        <button
            id="button_encrypt"
            className="btn btn-dark d-flex align-items-center justify-content-center"
            style={{}}
            onClick={() => {
                props.data.functionManager.encryptAES("Message test decrypted").then((value) => {
                    //TODO : after
                });
            }}
        >
            Encrypt
        </button>
        <button
            id="button_decrypt"
            className="btn btn-dark d-flex align-items-center justify-content-center"
            style={{}}
            onClick={() => {
                props.data.functionManager.decryptAES("Message test encrypted").then((value) => {
                    //TODO : after
                });
            }}
        >
            Decrypt
        </button>
    </div>);
}

async function getRSAPublicKeytoPEMasync(publicKey) {
    if (!publicKey) return;
    const bytesOfPublicKey = await crypto.subtle.exportKey("spki", publicKey);
    const RSAPublicKeyInBase64 = btoa(String.fromCharCode(...new Uint8Array(bytesOfPublicKey)));
    const result = "-----BEGIN PUBLIC KEY-----\n" + RSAPublicKeyInBase64 + "\n-----END PUBLIC KEY-----";
    //console.log(result);
    //console.log(publicKey.algorithm);
    return result;
}
async function encrypt(key, messageNotEncoded, iv) {
    if (!key) return;
    const messageNotEncodedToBytes = new TextEncoder().encode(messageNotEncoded);
    //console.log(key.algorithm)
    const algorithm = (iv) ? { name: key.algorithm.name, iv } : { name: key.algorithm.name };
    const encryptedMessage = await crypto.subtle.encrypt(algorithm, key, messageNotEncodedToBytes.buffer)
    const encryptedMessageBase64 = arrayBufferToBase64(encryptedMessage);
    return encryptedMessageBase64;
}
async function decrypt(key, messageEncoded, iv) {
    if (!key) return;
    const messageEncodedToBytes = base64ToArrayBuffer(messageEncoded);
    const algorithm = (iv) ? { name: key.algorithm.name, iv } : { name: key.algorithm.name };
    const decryptedMessage = await crypto.subtle.decrypt(algorithm, key, messageEncodedToBytes);
    return new TextDecoder().decode(decryptedMessage)
}

function arrayBufferToBase64(arrayBuffer) {
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
        const chunk = bytes.subarray(i, i + chunkSize);
        binary += String.fromCharCode(...chunk);
    }
    return btoa(binary);
}
/*function base64ToArrayBuffer(base64Text) {
    const binary = atob(base64Text);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
    //return bytes;
}*/

function base64ToArrayBuffer(base64Text) {
    return Uint8Array.from(atob(base64Text), c => c.charCodeAt(0));
    //return new TextDecoder().decode(Uint8Array.from(atob(base64Text), c => c.charCodeAt(0)));
}